import { useMemo } from 'react';

import { Box } from '@occc-app/design-system';
import { TableCell, TableRow } from '@occc/ui-design-system';
import { TrendBadgeDelta } from '@occc/ui-design-system';
import { RetailerNetworkTobaccoProgramSiteMetric } from '@occc/graphql';

const FIXED_DECIMALS = 2;
const COMPACT_NUMBER_THRESHOLD = 1000;

const smallNumFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: FIXED_DECIMALS,
});

const compactNumFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: FIXED_DECIMALS,
});

function formatValue(value: number) {
  if (!Number.isFinite(value)) {
    return '';
  }

  const abs = Math.abs(value);

  if (abs < COMPACT_NUMBER_THRESHOLD) {
    return smallNumFormatter.format(value);
  }

  return compactNumFormatter.format(value);
}

type LocationRankingTableRowProps = {
  item: RetailerNetworkTobaccoProgramSiteMetric;
};

export const LocationRankingTableRow = (props: LocationRankingTableRowProps) => {
  const { item } = props;

  const displayValue = useMemo(() => formatValue(item.value), [item.value]);

  return (
    <TableRow>
      <TableCell>{item.rank}</TableCell>
      <TableCell>{item.siteId}</TableCell>
      <TableCell>{item.siteName}</TableCell>
      <TableCell>{item.siteAddress}</TableCell>
      <TableCell align='right'>
        <Box display='inline-flex' alignItems='center' gap={1}>
          <TrendBadgeDelta value={item.value} prevValue={item.previousValue} />
          {displayValue}
        </Box>
      </TableCell>
    </TableRow>
  );
};
